import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputMask } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { Tag } from 'primeng/tag';
import Dealership from '../../../../../../types/dealership/Dealership';
import PhysicalSampleState from '../../../../../../types/physical-sample/PhysicalSampleState';
import PhysicalSampleWriteDTO from '../../../../../../types/physical-sample/PhysicalSampleWriteDTO';
import Sample from '../../../../../../types/sample/Sample';
import SelectOption from '../../../../../../types/shared/SelectOption';
import Studio from '../../../../../../types/studio/Studio';
import { DealershipService } from '../../../../services/dealership.service';
import { PhysicalSampleService } from '../../../../services/physical-sample.service';
import { SampleService } from '../../../../services/sample.service';
import { StudioService } from '../../../../services/studio.service';
import { UtilsService } from '../../../../services/utils.service';

@Component({
    selector: 'app-update-physical-sample-dialog',
    templateUrl: './update-physical-sample-dialog.component.html',
    styleUrls: [ './update-physical-sample-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IftaLabelModule,
        InputMask,
        Select,
        Tag
    ]
})
export class UpdatePhysicalSampleDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Input() physicalSample: PhysicalSampleWriteDTO = new PhysicalSampleWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() physicalSampleUpdated: EventEmitter<PhysicalSampleWriteDTO> =
        new EventEmitter<PhysicalSampleWriteDTO>();

    public availableStates: SelectOption[] = [];
    public availableDealerships: Dealership[] = [];
    public availableSamples: Sample[] = [];
    public availableStudios: Studio[] = [];
    public loading = false;
    public loadingDealerships = false;
    public loadingSamples = false;
    public loadingStudios = false;

    constructor(
        private physicalSampleService: PhysicalSampleService,
        private dealershipService: DealershipService,
        private sampleService: SampleService,
        private studioService: StudioService,
        private utilsService: UtilsService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.loadDealerships();
        this.loadSamples();
        this.loadStudios();
        this.availableStates = this.utilsService.createDropdownOptions(PhysicalSampleState);
    }

    get saveDisabled(): boolean {
        return !this.physicalSample.macAddress || !this.physicalSample.sampleId;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadDealerships() {
        this.loadingDealerships = true;
        this.dealershipService
            .getAllDealerships()
            .then((dealerships) => {
                this.availableDealerships = dealerships;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loadingDealerships = false;
            });
    }

    public loadSamples() {
        this.loadingSamples = true;
        this.sampleService
            .getAllSamples()
            .then((samples) => {
                this.availableSamples = samples;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loadingSamples = false;
            });
    }

    public loadStudios() {
        this.loadingStudios = true;
        this.studioService
            .getAllStudios()
            .then((studios) => {
                this.availableStudios = studios;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loadingStudios = false;
            });
    }

    public updatePhysicalSample() {
        this.loading = true;

        this.physicalSampleService
            .updatePhysicalSample(this.physicalSample)
            .then(() => {
                this.physicalSampleUpdated.emit(this.physicalSample);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
